import "./SmallHeading.css";
import ScrollAnimation from "../ScrollAnimation/ScrollAnimation";

const SmallHeading = ({ text, fillColour = "#111" }) => {
    return (
        <ScrollAnimation type="fade">
            <div className="small-heading">
                <svg
                    preserveAspectRatio="xMidYMid meet"
                    data-bbox="2.665 2.667 10.667 10.666"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="2.665 2.667 10.667 10.666"
                    height="16"
                    width="16"
                    data-type="color"
                    role="presentation"
                    aria-hidden="true"
                    aria-label=""
                >
                    <g>
                        <path
                            fill={fillColour}
                            d="M7.999 2.667 13.332 8l-5.333 5.333H2.665V2.667z"
                            data-color="1"
                        ></path>
                    </g>
                </svg>
                {text}
            </div>
        </ScrollAnimation>
    );
};

export default SmallHeading;
